var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 11.9167H6.25009C5.08711 11.9167 4.50563 11.9167 4.03246 12.0602C2.96713 12.3834 2.13345 13.217 1.81028 14.2824C1.66675 14.7555 1.66675 15.337 1.66675 16.5M15.8334 16.5V11.5M13.3334 14H18.3334M12.0834 5.25C12.0834 7.32107 10.4045 9 8.33342 9C6.26235 9 4.58341 7.32107 4.58341 5.25C4.58341 3.17893 6.26235 1.5 8.33342 1.5C10.4045 1.5 12.0834 3.17893 12.0834 5.25Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPerson);
export default __webpack_public_path__ + "static/media/add-person.6dd12c4dfd45aa01a2164f4ce7196c91.svg";
export { ForwardRef as ReactComponent };